<template>
  <!--
    	作者：gmshop
    	时间：2019-10-26
    	描述：商品管理-商品编辑-商品内容
    -->
  <div>
    <!--商品详情-->
    <div class="common-form mt50">商品详情</div>

    <!--内容-->
    <el-form-item label="内容：">
      <div class="d-s-c">
        <div class="edit_container">
          <Uediter :text="form.model.content" :config="ueditor.config" ref="ue" @contentChange="contentChangeFunc"></Uediter>
        </div>
        <div class="diy-phone">
          <div class="diy-phone-container">
            <!--顶部设置栏-->
              <div class="tc">详情预览</div>
              <div class="diy-phone-item wrapper">
                <div class="diy-richText" v-html="form.model.content">
                </div>
              </div>
          </div>
        </div>
        
      </div>
      
      
    </el-form-item>
  </div>
</template>

<script>
import Uediter from '@/components/UE.vue';
export default {
  components: {
    /*编辑器*/
    Uediter
  },
  data() {
    return {
      /*富文本框配置*/
      ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      }
    };
  },
  created() {
    //this.ueditor.text = this.form.model.content;
  },
  inject: ['form'],
  methods:{

    /*获取富文本框内容*/
    getContent: function() {
      //return this.$refs.ue.getUEContent();
    },

    /*获取富文本内容*/
    contentChangeFunc(e){
      this.form.model.content=e;
    }

  }
};
</script>

<style>
.diy-container {
    display: flex;
  }
  .diy-phone {
    width: 375px;
    margin: 0 30px;
    border: 1px solid #CCCCCC;
    border-radius: 10px;
    overflow: hidden;
  }
.diy-phone-container {
  position: relative;
  height: calc(100vh - 350px);
}
.diy-phone-container .wrapper {
  height:100%;
  overflow-y: auto;
}
.diy-phone-container .diy-phone-item > div {
  position: relative;
  border: 2px solid #f1f1f2;
}
</style>



// WEBPACK FOOTER //
// src/views/product/product/part/Content.vue